import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";
import { FAQS } from "@/data/site";
import { useSeo } from "@/lib/seo";
import { useLocale } from "@/context/LocaleContext";

const Faq = () => {
  const { locale, t } = useLocale();
  useSeo({
    title: locale === "en" ? "FAQ — Frequently asked questions about workshops, drums and care · Entre Les Mondes" : "FAQ — Questions fréquentes sur les stages, tambours et soins · Entre les Mondes",
    description: "Faut-il savoir jouer pour créer un tambour ? Quelles peaux choisir ? Comment se passe un soin à distance ? Toutes les réponses de Ludovic Isoz, Entre Les Mondes, Orbe.",
    jsonLd: { "@type": "FAQPage", mainEntity: FAQS.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.r } })) },
  });

  return (
    <div>
      <section className="bg-earth grain text-sand relative">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-44 pb-20 relative z-[2]">
          <Reveal>
            <p className="eyebrow mb-6 text-sand/70">FAQ</p>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-tight max-w-3xl">
              {locale === "en" ? "Questions we are often asked." : "Les questions que l'on nous pose souvent."}
            </h1>
          </Reveal>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-6 py-20 lg:py-28" data-testid="faq-list">
        <Reveal>
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`q-${i}`} className="border-sand-dark" data-testid={`faq-item-${i}`}>
                <AccordionTrigger data-testid={`faq-question-${i}`} className="font-serif text-lg lg:text-xl text-bark text-left hover:text-terra hover:no-underline py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-fumee leading-relaxed text-sm pb-6">
                  {f.r}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-14 text-center text-fumee text-sm">
            {locale === "en" ? "Is your question not here?" : "Votre question n'y est pas ?"}{" "}
            <Link to="/contact" data-testid="faq-contact-link" className="link-line text-terra">{locale === "en" ? "Write to us" : "Écrivez-nous"}</Link> — {locale === "en" ? "we reply within 48 hours." : "nous répondons sous 48 h."}
          </p>
        </Reveal>
      </section>
    </div>
  );
};

export default Faq;
